import { Configuration, ConfigurationParameters } from '@api/configuration';
import { ENV_CONFIG } from '@core/interfaces/configs';

export const apiConfigFactory = (env: ENV_CONFIG): Configuration => {
  const params: ConfigurationParameters = {
    basePath: env.apiBasePath || window.location.origin,
  };
  return new Configuration(params);
};
